import React, { Component } from 'react'
import { Footer } from "antd/lib/layout/layout";

export default class R2Footer extends Component {
    render() {
        return (
            <Footer style={{ backgroundColor: this.props.color }}>
                &copy; R2 Consulting 
            </Footer>
        )
    }
}
